import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import { OptionsSelector } from "../shared/optionsSelector";
import Pagination from '../shared/pagination';
import arrayUtilities from '../../utilities/arrayUtilities';
import {Modal} from 'react-bootstrap';
import { durationBetweenString, toDateString, toTimeString } from '../../utilities/dateUtilities';

function AllocatedBreaches(props) {
    const [breaches, setBreaches] = useState(null)
    const [allContraventions, setAllContraventions] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [users, setUsers] = useState(null);
    const [selectedUserId, setSelectedUserId] = useState(props.user.id);
    const [selectedBreaches, setSelectedBreaches] = useState([]);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [showUnassignModal, setShowUnassignModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const getAllContraventions = function () {
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getBreaches = function () {
        Api.getBreaches(
            (data) => {
                setBreaches(data);
                setSelectedBreaches([])
                setLoading(false);
            },
            (error) => console.log(error),
            null, null, selectedUserId, true, null, null, null, null, null, pageNumber, 0, null, null, null,
            null, null,
            null,
            props.organisationId,
            props.token,
        )
    };

    const getUsers = function () {
        Api.getUsers(
            (data) => setUsers(data.items),
            (error) => console.log(error),
            null, 0, 0,
            props.organisationId,
            props.token
        )
    };

    const changePageNumber = function (num) {
        setPageNumber(num);
    };

    const isLastPage = function () {
        if (breaches !== null && breaches !== undefined) {
            setLastPage(false);
            setPageCount(Math.ceil(breaches.totalCount / 100));
            if (pageNumber + 1 >= Math.ceil(breaches.totalCount / 100)) {
                setLastPage(true)
            }
        }
    };

    useEffect(() => {
        getBreaches();
        isLastPage();
        setLoading(true);
    }, [pageNumber, selectedUserId]);

    useEffect(() => {
        isLastPage();
    }, [breaches]);

    useEffect(() => {
        getBreaches();
        getAllContraventions();
        getUsers();
    }, [])

    const handleSelectionUpdate = (e, breach) => {
        if (e.target.checked) {
            setSelectedBreaches(prevState => [...prevState, breach.id])
            if (!arrayUtilities.isNullOrEmpty(breaches.items) && breaches.items.length - selectedBreaches.length === 1) {
                setIsSelectAllChecked(true)
            }
        } else if (!e.target.checked) {
            const index = selectedBreaches.findIndex(item => item === breach.id)
            setSelectedBreaches(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllChecked) {
                setIsSelectAllChecked(false)
            }
        }
    }

    const handleSelectAll = (e) => {
        setIsSelectAllChecked(!isSelectAllChecked)
        if (e.target.checked && !arrayUtilities.isNullOrEmpty(breaches.items)) {
            setSelectedBreaches(breaches.items.map(item => item.id))
        } else if (!e.target.checked) {
            setSelectedBreaches([])
        }
    }

    const handleConfirm = () => {
        Api.unassignBreaches(
            props.organisationId, selectedBreaches,
            () => {
                setShowUnassignModal(false);
                getBreaches();                
            },
            error => console.log(error),
            props.token
        )
    }

    const fetchSelectedUserName = (id) => {
        if (users) {
            const user = users.find(item => item.id === id)
            if (user !== undefined) {
                return `${user.firstName} ${user.lastName}`
            }
        }
    }

    return (
        <>
            {breaches === null && <Loader />}
            {breaches !== null && !arrayUtilities.isNullOrEmpty(users) &&
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-4 d-flex align-items-center pr-0">
                                            <h5 className="mb-0">Tickets allocated to {fetchSelectedUserName(selectedUserId)}</h5>
                                        </div>
                                        <div className="col-8 ml-auto text-right pl-0 filter-buttons-wrapper">
                                            {
                                                (props.user.isGlobalAdmin || props.user.organisations.find(item => item.organisation.id === props.organisationId).roleId <= 1) &&
                                                    <>
                                                        <OptionsSelector
                                                            label="Allocated to"
                                                            data={ users.reduce((acc, curr) => {
                                                                acc[curr.id] = fetchSelectedUserName(curr.id);
                                                                return acc;
                                                            }, {}) }
                                                            selectedValue={ selectedUserId }
                                                            handleOptionSelect={ value => setSelectedUserId(value) }
                                                        />
                                                        <button disabled={arrayUtilities.isNullOrEmpty(selectedBreaches)} className="btn btn-danger btn-sm ml-2" onClick={() => setShowUnassignModal(true)}><i className="fas fa-times"></i> Unassign</button>
                                                    </>
                                            }
                                            <button className="btn btn-primary btn-sm ml-2" onClick={() => {setBreaches(null); getBreaches();}}><i className="fas fa-redo"></i> Refresh</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container p-0">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>
                                                    <input name="select-all" id="select-all-breaches" value={ isSelectAllChecked } checked={ isSelectAllChecked } type="checkbox" onChange={ e => handleSelectAll(e) } />
                                                </th>
                                                <th>No.</th>
                                                <th>Reference Number</th>
                                                <th>VRM</th>
                                                <th>Contravention Date</th>
                                                <th>In Time</th>
                                                <th>Out Time</th>
                                                <th>Duration</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading === true && <><tr>
                                                <td colSpan={10}>
                                                    <Loader />
                                                </td></tr></>}
                                            {loading === false && <>
                                                {breaches !== null && allContraventions !== null && breaches.items.map((breach, i) => {
                                                    var url = '/organisation/' + props.organisationId + '/breach/' + breach.id;

                                                    var contravention;
                                                    allContraventions.forEach(item => {
                                                        if (item.id === breach.contraventionId) {
                                                            contravention = item;
                                                        }
                                                    });
                                                    i++;
                                                    var index = i + (100 * pageNumber);
                                                    return (
                                                        <tr key={breach.id}>
                                                            <td>
                                                                <input onChange={ (e) => handleSelectionUpdate(e, breach) } id={ breach.id } type="checkbox" checked={ selectedBreaches.includes(breach.id) } value={ breach.id } />
                                                            </td>
                                                            <td>{index}</td>
                                                            <td><Link to={url}><h6 className="mb-0">{breach.referenceNumber}</h6></Link></td>
                                                            <td><Link to={url} className="number-plate-link"><h6 className="mb-0 small-number-plate">{breach.vrm}</h6></Link></td>
                                                            <td className="">{toDateString(breach.timestamp)}</td>
                                                            {breach.parkingSession !== null && <>
                                                                <td>{toTimeString(breach.parkingSession.entry.timestamp)}</td>
                                                                <td>{toTimeString(breach.parkingSession.exit.timestamp)} </td>
                                                                <td>{durationBetweenString(breach.parkingSession.entry.timestamp, breach.parkingSession.exit.timestamp)}</td>
                                                            </>}
                                                            {breach.parkingSession === null && <>
                                                                <td></td>
                                                                <td>{toTimeString(breach.timestamp)}</td>
                                                                <td></td>
                                                            </>}
                                                            <td>{Enums.ContraventionTypes[contravention.contraventionType]}</td>
                                                            <td>{Enums.BreachStatus[breach.breachStatus]}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                            </>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="d-flex justify-content-center row align-items-center">
                                        <div className="col-auto align-items-center">
                                            <Pagination totalResults={breaches.totalCount} currentPage={pageNumber} changePageNumber={changePageNumber} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

                <Modal show={showUnassignModal} onHide={() => setShowUnassignModal(false)}>
                    <Modal.Header>
                        <Modal.Title>
                            Unassign {selectedBreaches.length} breach{selectedBreaches.length > 1 && <>es</>}?
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <button className="btn btn-falcon-default btn-sm ml-2" onClick={() => setShowUnassignModal(false)}>Cancel</button>
                        <button className="btn btn-success btn-sm ml-2" onClick={() => handleConfirm()}>Confirm</button>
                    </Modal.Footer>
                </Modal>
        </>
    )
}

export default AllocatedBreaches;